/** @format */

import Header from "../../components/home/header/header";
import styled from "styled-components";
import Giftcard from "../../assets/images/Lost in social networks.png";
import SubmitButton from "../../components/atoms/submitbutton";
import { Link, useNavigate } from "react-router-dom";
import { API_URL } from "../../constants";
import { useDispatch } from "react-redux";
import { loginSuccess, loginFailed } from "../../redux/auth";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import axios from "axios";
import { toast } from "react-toastify";
import { loginSchema } from "../../validations/login";
import { useState } from "react";

const Input = styled.input`
  background: #ffffff;
  border: 1px solid #d1d1d1;
  border-radius: 9px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 1em;
  width: ${(props) => props.width};
  line-height: 18px;
  margin: 0.625em 0;
  display: flex;
  height: 2.5em;
  width: 19.6em;
  color: #4a4a4a;

  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    margin: 0.625em auto;
    width: 100%;
  }
  @media (max-width: ${({ theme }) => theme.mobile.sm}) {
  }
`;

const MainSection = styled.div`
  display: flex;
  margin-left: 8%;
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    margin-left: auto;
    display: block;
    align-items: center;
    height: 90vh;
  }
`;
const LoginSection = styled.div`
  width: 100%;
  padding: 0 10%;
  margin: 0 auto;
  margin-top: 3.75em;
  display: flex;
  justify-content: center;
  form {
    width: 100%;
  }
  h2 {
    font-size: 1.8em;
    font-weight: 700;
  }
  .bold {
    font-weight: 700;
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    width: 100%;
  }
`;

const ImageSection = styled.div`
  width: 100%;
  margin-top: 3.7em;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 60%;
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    /* width: 50%; */
    margin: 0 auto;
    margin-top: 3.7em;
  }
`;

type Formdata = yup.InferType<typeof loginSchema>;

const Login = () => {
  const [isloading, setisloading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // using form hook to login

  const { register, handleSubmit, formState } = useForm<Formdata>({
    resolver: yupResolver(loginSchema),
  });
  const { errors } = formState;

  const loginRequest = async (data: any) => {
    setisloading(true);
    axios
      .post(`${API_URL}/login`, {
        email: data.email,
        password: data.password,
      })
      .then((response: any) => {
        if (response.status === 200) {
          dispatch(loginSuccess(response.data.data));
          setisloading(false);
          navigate("/dashboard");
          return;
        }
        toast.error(response.message);
      })
      .catch((error) => {
        setisloading(false);
        if (error?.response?.status === 401) {
          toast.error(error?.response?.data?.message);
          dispatch(loginFailed());
          return;
        }
        toast.error(`Connection Failed`);
      });
  };

  return (
    <>
      <Header />
      <MainSection>
        <ImageSection>
          <img src={Giftcard} alt="" />
        </ImageSection>
        <LoginSection>
          <form onSubmit={handleSubmit(loginRequest)}>
            <h2 className="mb-5">Sign in</h2>
            <Input
              autoComplete="email"
              className="p-3"
              {...register("email")}
              type="email"
              placeholder="Email"
              name="email"
              width="100%"
            />
            {errors?.email && (
              <p className="text-xs mb-2 text-red-600">
                {errors.email?.message}
              </p>
            )}
            <Input
              autoComplete="password"
              className="p-3"
              {...register("password")}
              type="password"
              placeholder="Password"
              name="password"
            />
            {errors?.password && (
              <p className="text-xs   text-red-600">
                {errors.password?.message}
              </p>
            )}
            <h6 className="mt-[1em] mb-[1em]]">
              <u>
                <Link to="/recover">Forgot Password?</Link>
              </u>
            </h6>
            <SubmitButton
              value={"Sign in"}
              isloading={isloading}
              width="19.6em"
            />

            <h5 className="mt-[1em] mb-[2.5em]">
              New here?{" "}
              <u className="bold">
                <Link to="/register">Register</Link>
              </u>
            </h5>
          </form>
        </LoginSection>
      </MainSection>
    </>
  );
};

export default Login;
